import React, { useMemo, useCallback } from "react";
import clsx from "clsx";
import { MenuItem } from "../redux/slices/menuSlice";

interface BuilderCategoryFilterProps {
  builderItems: MenuItem[];
  selectedItemId: string | null;
  onItemChange: (itemId: string | null) => void;
}

const BuilderCategoryFilter: React.FC<BuilderCategoryFilterProps> = ({
  builderItems,
  selectedItemId,
  onItemChange,
}) => {
  // Sort items by name for consistent display
  const sortedItems = useMemo(() => {
    return [...builderItems].sort((a, b) => a.name.localeCompare(b.name));
  }, [builderItems]);

  const handleItemClick = useCallback(
    (itemId: string | null) => {
      // Toggle: if clicking active item, collapse it (set to null)
      if (selectedItemId === itemId) {
        onItemChange(null);
      } else {
        onItemChange(itemId);
      }
    },
    [selectedItemId, onItemChange]
  );

  if (sortedItems.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <div className="flex border-b-2 border-gray-200 overflow-x-auto scrollbar-hide">
        {/* Individual Item Tabs */}
        {sortedItems.map((item) => {
          const isActive = selectedItemId === item.pk_id;
          return (
            <button
              key={item.pk_id}
              onClick={() => handleItemClick(item.pk_id)}
              aria-pressed={isActive}
              className={clsx(
                "px-4 pb-3 text-sm font-semibold whitespace-nowrap transition-all uppercase",
                isActive 
                  ? "border-b-2 border-solid" 
                  : "text-gray-600 hover:text-gray-900"
              )}
              style={isActive ? { color: '#EF4421', borderBottomColor: '#EF4421' } : undefined}
            >
              {item.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(BuilderCategoryFilter);
